const toggleSwitch = () => {
    const docBody = $(document.body);

    docBody.on('click', '.toggle-switch', (e) => {
        const thisTarget = $(e.currentTarget);
        const targetSelector = thisTarget.data('target');
        const targetSelectorType = thisTarget.data('target-type') === 'id' ? '#' : '.';
        const elementToggled = $(`${targetSelectorType}${targetSelector}`);
        thisTarget.toggleClass('active');

        if (!elementToggled.is(':visible')) {
            elementToggled.slideDown();
        }

        if (!thisTarget.hasClass('active') && elementToggled.is(':visible')) {
            elementToggled.slideUp();
        }

        if (targetSelector === 'gift-message-block') {
            elementToggled.find('.custom-control-input.gift').trigger('click');
        }
    });
};

module.exports = {
    toggleSwitch,
};
